/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_SIMPLE_DISPLAY_SNAPSHOTS = gql`
  query GetSimpleDisplaySnapshots(
    $filters: DisplaySnapshotFilter!
    $order: DisplaySnapshotOrder
    $pagination: OffsetPaginationInput
  ) {
    tenantDisplaySnapshots(
      filters: $filters
      order: $order
      pagination: $pagination
    ) {
      results {
        id
        captureTime
        display {
          id
          name
          store {
            location {
              name
            }
          }
        }
        user {
          id
          firstName
          lastName
          email
        }
        score {
          score
        }
      }
      totalCount
    }
  }
`
